import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import { HeroBanner } from '../../components';
import SEO from '../../components/SEO';
const HomePage = ({ setRefs }) => {
  const homeRef = useRef(null);

  useEffect(() => {
    setRefs({ home: homeRef });
  }, [setRefs]);

  return (
    <>
      <SEO
        title="Home"
        description="OctopusSync - Synchronize your digital future with seamless integration solutions."
        keywords="octopus, sync, integration, automation, business, digital transformation"
      />
      <Box 
        ref={homeRef}
        id="home"
        sx={{ 
          backgroundColor: 'var(--neutral-white)',
          minHeight: '100vh',
          position: 'relative'
        }}
      >
        <HeroBanner />
    
        
        {/* Additional sections can be added here */}
        
      </Box>
    </>
  );
};

export default HomePage;
